import addNotification from 'react-push-notification';

const notify = (message) => {
  addNotification({
            title: 'СеваитАгро',
            subtitle: 'Портал',
            message: message,
            theme: 'darkblue',
            native: true // when using native, your OS will handle theming.
        });
  // navigator.serviceWorker.register("sw.js");
  // try {
  //   // Проверка поддержки браузером уведомлений
  //   if (!("Notification" in window)) {
  //     alert("This browser does not support desktop notification");
  //   }

  //   // Проверка разрешения на отправку уведомлений
  //   else if (Notification.permission === "granted") {
  //     // Если разрешено, то создаем уведомление
  //     try {
  //       var notification = new Notification(message);
  //     } catch (error) {
  //       navigator.serviceWorker.ready.then((registration) => {
  //         registration.showNotification("Уведомление от доски", {
  //           body: message,
  //           // icon: "../images/touch/chrome-touch-icon-192x192.png",
  //           vibrate: [200, 100, 200, 100, 200, 100, 200],
  //           tag: "vibration-sample",
  //         });
  //       })
  //     }
  //   }

  //   // В противном случае, запрашиваем разрешение
  //   else if (Notification.permission !== 'denied') {
  //     Notification.requestPermission(function (permission) {
  //       // Если пользователь разрешил, то создаем уведомление 
  //       if (permission === "granted") {
  //         try {
  //             var notification = new Notification(message);
  //           } catch (error) {
  //             navigator.serviceWorker.ready.then((registration) => {
  //               registration.showNotification("Уведомление от доски", {
  //                 body: message,
  //                 // icon: "../images/touch/chrome-touch-icon-192x192.png",
  //                 vibrate: [200, 100, 200, 100, 200, 100, 200],
  //                 tag: "vibration-sample",
  //               });
  //             })
  //           }
  //       }
  //     });
  //   }
  // } catch (error) {
  //   alert(error)
  // }
  
}

export default notify
    